<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter class="align-items-center">
          <md-layout style="position: absolute;">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              style="margin: 0;"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <!-- <md-layout md-flex="25"></md-layout> -->
          <md-layout class="justify-content-center">
            <h2 style="text-align:center">Sea Import(Consolidation)</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="90"></md-layout>
          <md-layout md-flex="10">
            <md-button
              v-if="ffExoprtDetail.conSeaImportId!=''"
              @click="addStatus"
              style="position: fixed;z-index:999;top:83%;"
              class="md-fab"
            >
              <md-icon>message</md-icon>
            </md-button>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="align-items-center pl-2 pr-2">
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="10">
            <label>
              <u>Job Type</u>
            </label>
          </md-layout>

          <md-layout
            v-for="(segmentNameArray, index) in showSegmentArray"
            :key="index"
            :md-flex="segmentNameArray.flex"
          >
            <md-checkbox
              v-model="ffExoprtDetail.jobType[index]"
              class="md-primary"
              :md-value="segmentNameArray.value"
              :name="'jobType'+(index+1)"
              :id="'jobType'+(index+1)"
              @change="jobTypeSelect(segmentNameArray.value,index)"
            >{{segmentNameArray.show}}</md-checkbox>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />

        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="transportType">Import</label>
            <model-list-select
              :list="transportTypeList"
              isDisabled
              v-model="ffExoprtDetail.transportType"
              option-value="transportTypeVal"
              option-text="transportTypeText"
              placeholder="Select  Type"
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="containerInfo">FF Activity</label>
            <model-list-select
              :list="containerInfoList"
              v-model="ffExoprtDetail.containerInfo"
              option-value="containerInfoVal"
              option-text="containerInfoText"
              placeholder="Select Type"
              :isDisabled="ffExoprtDetail.conSeaImportId==''?false:true"
            ></model-list-select>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="justify-content-end">
          <!-- <md-layout md-flex="25"></md-layout> -->
          <md-layout md-flex="50" class="pl-2 pr-2">
            <span
              class="error"
              v-if="!ffExoprtDetail.containerInfo"
            >{{ffExporterrorList.containerInfo}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="50" class="pl-2 pr-2">
            <label for="shippingId">Shipping Line Name</label>
            <model-list-select
              :list="shippingList"
              v-model="ffExoprtDetail.shippingId"
              option-value="shippingId"
              option-text="shippingLine"
              placeholder="Select Shipping Line "
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>Date of Sail</label>
            <date-picker 
              :format="selectDateFormat"
              width="100%"
              lang="en" 
              id="sailDate" 
              name="sailDate" 
              v-model="ffExoprtDetail.sailDate"></date-picker>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>Pre-Alert Received Date</label>
            <date-picker
              :format="selectDateFormat"
              width="100%"
              lang="en"
              id="alertReceivedDate"
              name="alertReceivedDate"
              v-model="ffExoprtDetail.alertReceivedDate"
            ></date-picker>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="50" class="pl-2 pr-2">
            <span class="error" v-if="!ffExoprtDetail.shippingId">{{ffExporterrorList.shippingId}}</span>
          </md-layout>
          <md-layout md-flex="25" class="pl-2 pr-2">
            <span class="error" v-if="!ffExoprtDetail.sailDate">{{ffExporterrorList.sailDate}}</span>
          </md-layout>
          <md-layout md-flex="25" class="pl-2 pr-2">
            <span
              class="error"
              v-if="!ffExoprtDetail.alertReceivedDate"
            >{{ffExporterrorList.alertReceivedDate}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="50" class="pl-2 pr-2">
            <label>Ocean Vessel and Voyage</label>
            <b-form-input :formatter="capitalizeAll"
              id="vesselVoyage"
              name="vesselVoyage"
              v-model="ffExoprtDetail.vesselVoyage"
            ></b-form-input>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="50" class="pl-2 pr-2">
            <label>Pre Carriage By</label>
            <b-form-input :formatter="capitalizeAll"
              id="preCarriageBy"
              name="preCarriageBy"
              v-model="ffExoprtDetail.preCarriageBy"
            ></b-form-input>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />
        <md-layout md-gutter >
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>Master B/L Number</label>
            <b-form-input :formatter="capitalizeAll"
              id="firstBLNumber"
              name="firstBLNumber"
              v-model="ffExoprtDetail.firstBLNumber"
              @keyup="containerNoRegexfun"
            ></b-form-input>
            <!-- type="Number" -->
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>Master B/L Date</label>
            <date-picker
             width="100%"
            :format="selectDateFormat"
              lang="en"
              id="firstBLDate"
              name="firstBLDate"
              v-model="ffExoprtDetail.firstBLDate"
            ></date-picker>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="firstBlType">B/L Type</label>
            <model-list-select
              :list="blTypeList"
              v-model="ffExoprtDetail.firstBlType"
              option-value="blTypeVal"
              option-text="blTypeTxt"
              placeholder="Select B/L Type"
              isDisabled
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="10" class="pl-2 pr-2">
            <md-radio
              style="margin: 0; align-self: end;
              padding-bottom: 0.7rem;"
              id="permitted1"
              name="permitted1"
              md-value="Original"
              v-model="ffExoprtDetail.firstBLRadio"
              class="md-primary"
            >Original</md-radio>
          </md-layout>

          <md-layout md-flex="10" class="pl-2 pr-2">
            <md-radio
              style="margin: 0;align-self: end;
              padding-bottom: 0.7rem;"
              id="permitted2"
              name="permitted2"
              v-model="ffExoprtDetail.firstBLRadio"
              md-value="seaWayBl"
              class="md-primary"
            >Sea Way</md-radio>
          </md-layout>
        </md-layout>

        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <span
            class="error"
            v-if="!ffExoprtDetail.firstBLNumber"
          >{{ffExporterrorList.firstBLNumber}}</span>
          <span class="error" v-else-if="blRegexError!=''">{{blRegexError}}</span>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="deliveryTerms">Ocean Freight</label>
            <model-list-select
              :list="oceanFreightTermsList"
              v-model="ffExoprtDetail.firstOcFreghtTerms"
              option-value="oceanFreightTermsVal"
              option-text="oceanFreightTermsText"
              placeholder="Select"
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <md-input-container>
              <label>Upload B/L</label>
              <md-file
                name="firstBLupload"
                id="firstBLupload"
                v-model="ffExoprtDetail.firstBLupload"
                @selected="onFileChangeFirstBl"
                multiple
              ></md-file>
            </md-input-container>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="justify-content-end" v-if="firstBlUploadView.length>0">
          <!-- <md-layout md-flex="35"></md-layout> -->
          <md-layout md-flex="15" v-for="(item,index) in firstBlUploadView" :key="index">
            <a
              :href="`${this.docURL}/dummy/`+item"
              target="_blank"
              download
              v-if="ffExoprtDetail.conSeaImportId==''"
            >View Document - {{index+1}}</a>
            <a
              :href="`${this.docURL}/SeaImportCon/`+item"
              target="_blank"
              download
              v-else
            >View Document - {{index+1}}</a>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="PORlocationId">Place of Receipt</label>
            <model-list-select
              @input="getLocationList($event,'Icd,Sea_Port','IcdPOrtList')"
              @searchchange="getLocationList($event,'Icd,Sea_Port','IcdPOrtList')"
              :list="IcdPOrtListNew"
              v-model="ffExoprtDetail.PORlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Place of Receipt"
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="LPlocationId">Port of Loading</label>
            <model-list-select
              @input="getLocationList($event,'Sea_Port','PortLoadList')"
              @searchchange="getLocationList($event,'Sea_Port','PortLoadList')"
              :list="PortLoadList"
              v-model="ffExoprtDetail.LPlocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Loading Port Name"
              :isDisabled="ffExoprtDetail.portType!='Icd'?true:false"
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="50" class="pl-2 pr-2">
            <label for="cargoDestufLocationId">Cargo Destuffing Location</label>
            <model-list-select
              @input="getLocationList($event,'All','CargoDesData')"
              @searchchange="getLocationList($event,'All','CargoDesData')"
              :list="CargoDesData"
              v-model="ffExoprtDetail.cargoDestufLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Location"
            ></model-list-select>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <span
              class="error"
              v-if="!ffExoprtDetail.PORlocationId"
            >{{ffExporterrorList.PORlocationId}}</span>
          </md-layout>
          <md-layout md-flex="25" class="pl-2 pr-2">
            <span
              class="error"
              v-if="!ffExoprtDetail.LPlocationId"
            >{{ffExporterrorList.LPlocationId}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label for="PODLocationId">Port of Discharge</label>
            <model-list-select
              @input="getLocationList($event,'Sea_Port','getPortDischargeList')"
              @searchchange="getLocationList($event,'Sea_Port','getPortDischargeList')"
              :list="PortDischargeList"
              v-model="ffExoprtDetail.PODLocationId"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select POD"
            ></model-list-select>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->

          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>ETA @ Discharge Port</label>
            <date-picker
             width="100%"
            :format="selectDateFormat"
              lang="en"
              id="etaDischargePort"
              name="etaDischargePort"
              v-model="ffExoprtDetail.etaDischargePort"
            ></date-picker>
          </md-layout>
          <!-- <md-layout md-flex="10"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <label>ETA @ Final Destination</label>
            <date-picker
             width="100%"
            :format="selectDateFormat"
              lang="en"
              id="etaFinalPort"
              name="etaFinalPort"
              v-model="ffExoprtDetail.etaFinalPort"
            ></date-picker>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="25" class="pl-2 pr-2">
            <span
              class="error"
              v-if="!ffExoprtDetail.PODLocationId"
            >{{ffExporterrorList.PODLocationId}}</span>
          </md-layout>
        </md-layout>
        <md-layout md-gutter>
          <!-- <md-layout md-flex="40"></md-layout> -->
          <md-layout md-flex="50" class="pl-2 pr-2">
            <md-layout md-flex="100">
              <label>Free Detention Days at Destination(Import Port)</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                id="freeDetentionDesti"
                name="freeDetentionDesti"
                v-model="ffExoprtDetail.freeDetentionDesti"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="25" class="pl-2 pr-2">
            <md-layout md-flex="100">
              <label>Last Free Days</label>
              <b-form-input :formatter="capitalizeAll"
                type="number"
                id="lastFreeDay"
                name="lastFreeDay"
                disabled
                v-model="ffExoprtDetail.lastFreeDay"
              ></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout gutter>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="100" class="pl-2 pr-2">
            <label>Remarks</label>
            <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks" v-model="ffExoprtDetail.ffExportremarks"></b-form-textarea>
          </md-layout>
        </md-layout>
        <hr class="hr-s" />

        <md-layout md-gutter v-if=" multipleHouseBLData.length>0">
          <md-layout md-flex="75"></md-layout>

          <md-layout md-flex="25">
            <h4
              @click="showMoreShipper"
              class="showMoreData"
            >Click here to {{openShipper==true?"Hide":"Add More"}} House BL</h4>

            <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
          </md-layout>
        </md-layout>
        <md-layout gutter class>
          <!-- <md-layout md-flex="5"></md-layout> -->
          <md-layout md-flex="80" class="pl-2 pr-2">
            <h3>House B/L Wise :</h3>
          </md-layout>
        </md-layout>
        <div v-if="multipleHouseBLData.length==0 || openShipper==true">
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="clientId">Importer Name</label>

              <model-list-select
                :list="clientList"
                id="clientNamenew"
                v-model="ffHouseBL.importerClientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Importer Name"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="clientId">Exporter Name</label>

              <model-list-select
                :list="clientList"
                id="clientNamenew"
                v-model="ffHouseBL.exporterClientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Exporter Name"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="50" class="pl-2 pr-2">
              <label for="finalPlaceLocationId">Final Place of Delivery</label>
              <model-list-select
                @input="getLocationList($event,'All','finalAllPlaceData')"
                @searchchange="getLocationList($event,'All','finalAllPlaceData')"
                :list="finalAllPlaceData"
                v-model="ffHouseBL.finalPlaceLocationId"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Final Place of Delivery"
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25"  class="pl-2 pr-2">
              <span
                class="error"
                v-if="!ffHouseBL.importerClientId"
              >{{errorHouseBL.importerClientId}}</span>
            </md-layout>
            <!-- <md-layout md-flex="10"></md-layout> -->
            <span class="error pl-2 pr-2" v-if="!ffHouseBL.exporterClientId">{{errorHouseBL.exporterClientId}}</span>
            <!-- <md-layout md-flex="15"></md-layout> -->
            <span
              class="error pl-2 pr-2"
              v-if="!ffHouseBL.finalPlaceLocationId"
            >{{errorHouseBL.finalPlaceLocationId}}</span>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="50"  class="pl-2 pr-2">
              <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />
          <md-layout md-gutter>
           <!-- ?-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>House B/L Number</label>
              <b-form-input :formatter="capitalizeAll"
                id="secondBLNumber"
                name="secondBLNumber"
                v-model="ffHouseBL.secondBLNumber"
                @keyup="houseBLRegexfun"
              ></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>House B/L Date</label>
              <date-picker
              width="100%"
              :format="selectDateFormat"
                lang="en"
                id="secondBLDate"
                name="secondBLDate"
                v-model="ffHouseBL.secondBLDate"
              ></date-picker>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="secondBlType">B/L Type</label>
              <model-list-select
                :list="blTypeList"
                v-model="ffHouseBL.secondBlType"
                option-value="blTypeVal"
                option-text="blTypeTxt"
                placeholder="Select B/L Type"
                :isDisabled="true"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="10" class="pl-2 pr-2">
              <md-radio
               style="margin: 0;align-self: end; padding-bottom: 0.7rem;"
                id="permitted1"
                name="permitted1"
                md-value="Original"
                v-model="ffHouseBL.secondBLRadio"
                class="md-primary"
              >Original</md-radio>
            </md-layout>

            <md-layout md-flex="10">
              <md-radio
                style="margin: 0;align-self: end; padding-bottom: 0.7rem;"
                id="permitted2"
                name="permitted2"
                v-model="ffHouseBL.secondBLRadio"
                md-value="seaWayBl"
                class="md-primary"
              >Sea Way</md-radio>
            </md-layout>
          </md-layout>

          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <span class="error" v-if="!ffHouseBL.secondBLNumber">{{errorHouseBL.secondBLNumber}}</span>
            <span class="error" v-else-if="houseblRegexError!=''">{{houseblRegexError}}</span>
          </md-layout>
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="secondOcFreghtTerms">Ocean Freight</label>
              <model-list-select
                :list="oceanFreightTermsList"
                v-model="ffHouseBL.secondOcFreghtTerms"
                option-value="oceanFreightTermsVal"
                option-text="oceanFreightTermsText"
                placeholder="Select"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <md-layout md-flex="100">
                <md-input-container>
                  <label>Upload B/L</label>
                  <md-file
                    name="secondBLupload"
                    id="secondBLupload"
                    v-model="ffHouseBL.secondBLupload"
                    multiple
                    @selected="onFileChangeSecondBl"
                  ></md-file>
                </md-input-container>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter v-if="SecondBlUploadView.length>0">
            <md-layout md-flex="35"></md-layout>
            <md-layout md-flex="15" v-for="(item,index) in SecondBlUploadView" :key="index">
              <a
                :href="`${this.docURL}/dummy/`+item"
                target="_blank"
                download
                v-if="ffHouseBL.conSeaMultiBlId==''"
              >View Document - {{index+1}}</a>
              <a
                :href="`${this.docURL}/SeaImportCon/`+item"
                target="_blank"
                download
                v-else
              >View Document - {{index+1}}</a>
            </md-layout>
          </md-layout>

          <hr class="hr-border" />
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
              <model-list-select
                :list="deliveryTermsList"
                v-model="ffHouseBL.deliveryTerms"
                option-value="deliveryTermsVal"
                option-text="deliveryTermsText"
                placeholder="Select Delivery Terms"
              ></model-list-select>
            </md-layout>
<!-- 
            <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <!-- <h4 style="padding:0px;margin:0px"></h4> -->
              <label for="ccType">Custom Clearence Type</label>
              <model-list-select
                :list="cctypeList"
                v-model="ffHouseBL.ccType"
                option-value="ccTypeVal"
                option-text="ccTypeTxt"
                placeholder="Select  Type"
              ></model-list-select>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2" v-if="ffHouseBL.ccType=='Outsourced'">
              <label>CHA Name</label>
              <b-form-input :formatter="capitalizeAll" id="ccCha" name="ccCha" v-model="ffHouseBL.ccCha"></b-form-input>
            </md-layout>
          </md-layout>

          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="35"></md-layout>
            <span class="error" v-if="!ffHouseBL.ccType">{{errorHouseBL.ccType}}</span>
          </md-layout>
          <md-layout md-gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="shipmentType">Source Of Booking</label>
              <!-- shipType is for source of booking -->
              <model-list-select
                :list="shipTypeList"
                v-model="ffHouseBL.shipType"
                option-value="shipTypeVal"
                option-text="shipTypeText"
                placeholder="Select Source Of Booking "
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2" v-if="ffHouseBL.shipType=='Destination'">
              <label for="agentName">Agent Name</label>
              <model-list-select
                :list="agentNameList"
                v-model="ffHouseBL.agentName"
                option-value="agntColoaderId"
                option-text="agentName"
                placeholder="Select Agent Name"
              ></model-list-select>
            </md-layout>
            <md-layout md-flex="25" class="pl-2 pr-2" v-if="ffHouseBL.shipType=='Origin'">
              <label for="sourceOriginclientId">Client Name</label>
              <model-list-select
                :list="clientList"
                id="clientNamenew"
                v-model="ffHouseBL.sourceOriginclientId"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select Client Name"
              ></model-list-select>
            </md-layout>

            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2" v-if="ffHouseBL.shipType=='Destination'">
              <label>Buyer Name</label>
              <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer" v-model="ffHouseBL.buyer"></b-form-input>
            </md-layout>

            <md-layout md-flex="25" class="pl-2 pr-2" v-if="ffHouseBL.shipType=='Origin'">
              <label>Enter Buying House</label>
              <b-form-input :formatter="capitalizeAll" id="buyingHouse" name="buyingHouse" v-model="ffHouseBL.buyingHouse"></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="30" class="pl-2 pr-2" v-if="ffHouseBL.shipType=='Origin'">
              <label>Other Specify</label>
              <b-form-input :formatter="capitalizeAll" id="otherSpecify" name="otherSpecify" v-model="ffHouseBL.otherSpecify"></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <md-layout
              md-flex="25"
              v-for="(singleInput, index) in ffHouseBL.notifyList"
              :key="index"
            >
              <md-layout md-flex="100" class="pl-2 pr-2">
                <!-- <md-layout md-flex="15"></md-layout> -->
                <md-layout md-flex="80">
                  <label>{{ notifyArray[index] }} Notify Name & Address</label>
                </md-layout>
                <md-layout md-flex="15" v-if="index>1">
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="removeNotify(index)"
                    style="min-height:20px;height:20px"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                </md-layout>
              </md-layout>

              <md-layout md-flex="100" class="pl-2 pr-2">
                <!-- <md-layout md-flex="15"></md-layout> -->
                <md-layout md-flex="100">
                  <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor>
                </md-layout>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="30" class="pl-2 pr-2">
              <label class="showMoreData" @click="addNotify">Add Notify</label>
              <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>

          <md-layout gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>Marks & Nos.</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="houseMarksNos"
                name="houseMarksNos"
                v-model="ffHouseBL.houseMarksNos"
              ></b-form-textarea>
            </md-layout>

            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>Container No./ Seal No.</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="houseContainerSealNo"
                name="houseContainerSealNo"
                v-model="ffHouseBL.houseContainerSealNo"
              ></b-form-textarea>
            </md-layout>

            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="50" class="pl-2 pr-2">
              <label>Commodity Name, HSN Code and Type</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="houseCommodity"
                name="houseCommodity"
                v-model="ffHouseBL.houseCommodity"
              ></b-form-textarea>
            </md-layout>
          <!-- </md-layout>

          <md-layout gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>No. Of Containers/Packages</label>
              <b-form-input :formatter="capitalizeAll" id="houseNoOfPkg" name="houseNoOfPkg" v-model="ffHouseBL.houseNoOfPkg"></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>Gross Wgt. of Cargo</label>
              <b-form-input :formatter="capitalizeAll"
                id="houseGrossWeightCargo"
                name="houseGrossWeightCargo"
                v-model="ffHouseBL.houseGrossWeightCargo"
              ></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="25" class="pl-2 pr-2">
              <label>Net Wgt. of Cargo</label>
              <b-form-input :formatter="capitalizeAll"
                id="Measurement"
                name="Measurement"
                v-model="ffHouseBL.houseVolumeWeightCargo"
              ></b-form-input>
            </md-layout>
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="25" class="pl-2 pr-2">
              <label for="deliveryMode">Measurement(CBM)</label>
              <b-form-input :formatter="capitalizeAll"
                id="Measurement"
                name="Measurement"
                v-model="ffHouseBL.houseFinalChargeableWeight"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout gutter>
            <!-- <md-layout md-flex="5"></md-layout> -->

            <md-layout md-flex="100" class="pl-2 pr-2">
              <label>Description of Goods</label>
              <b-form-textarea :formatter="capitalizeAll"
                id="houseDescriptionGood"
                name="houseDescriptionGood"
                v-model="ffHouseBL.houseDescriptionGood"
              ></b-form-textarea>
            </md-layout>
          </md-layout>
          <md-layout gutter >
            <!-- <md-layout md-flex="5"></md-layout> -->
            <md-layout md-flex="100" class="pl-2 pr-2">
              <label>Remarks</label>
              <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks" v-model="ffHouseBL.remarks"></b-form-textarea>
            </md-layout>
          </md-layout>

          <hr class="hr-border" />

          <md-layout md-gutter class="justify-content-center">
            <!-- <md-layout md-flex="45"></md-layout> -->
            <md-button
              class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
              id="addButtonLoader"
              @click="addFFSeaImport('')"
            >Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>

          <hr class="hr-border" v-if="multipleHouseBLData.length>0" />
        </div>

        <table
          id="conBooking"
          class="table table-bordered table-striped"
          v-if="multipleHouseBLData.length>0"
        >
          <thead>
            <tr>
              <th>Sr no</th>
              <th>House BL Number</th>
              <th>Importer Name</th>
              <th>Exporter Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item1,index) in multipleHouseBLData" :key="index">
              <td>{{index+1}}</td>

              <td
                @click="EditHouseBL(item1)"
                class="showMoreData"
              >{{item1.secondBLNumber==null || item1.secondBLNumber==""?"N/A":item1.secondBLNumber}}</td>
              <td>{{item1.ImporterName}}</td>
              <td>{{item1.ExporterName }}</td>
            </tr>
          </tbody>
        </table>

        <hr class="hr-border" v-if="multipleHouseBLData.length>0 && ffHouseBL.conSeaMultiBlId==''" />
        <md-layout
          md-gutter
          class="mrgtop-button"
          v-if="multipleHouseBLData.length>0 && ffHouseBL.conSeaMultiBlId==''"
        >
          <md-layout md-flex="70"></md-layout>
          <md-button
            class="md-raised md-primary md-button-color heght-1px mrgtop-2per"
            id="addButtonLoader"
            @click="addFFSeaImport('fdsf')"
          >Proceed to Execution</md-button>
          <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
        </md-layout>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="alertAddSeaImp"
      @close="onCloseAddSeaImp"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/conSeaImport/ffConSeaImportFcl"
      );
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {
    ffExoprtDetail: {
      handler: function(newVal, oldVal) {
        if (this.ffExoprtDetail.etaDischargePort != "") {
          this.getDayFromDate = new Date(
            this.ffExoprtDetail.etaDischargePort
          ).getDate();

          this.ffExoprtDetail.lastFreeDay =
            parseInt(this.getDayFromDate) +
            parseInt(this.ffExoprtDetail.freeDetentionDesti);
        }
        if (this.ffExoprtDetail.PORlocationId != "") {
          let array = this.IcdPOrtList.filter(x => {
            return x.pickupId == newVal.PORlocationId;
          })[0];
          console.log(array, "vdfds");

          this.ffExoprtDetail.portType = array.locationType;
          if (array.locationType != "Icd") {
            this.PortLoadList = this.IcdPOrtList;
            this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
          }

          this.deliveryTermsList[1].deliveryTermsText =
            "FOB_POR_ " + array.mainLocation;
        }
        if (this.ffExoprtDetail.LPlocationId != "") {
          let array = this.PortLoadList.filter(x => {
            return x.pickupId == this.ffExoprtDetail.LPlocationId;
          })[0];
          this.deliveryTermsList[2].deliveryTermsText =
            "FOB_LP_ " + array.mainLocation;
        }
      },
      deep: true
    }
  },
  data() {
    return {
      selectDateFormat,
      editorOption: {
        modules: {}
      },
      docURL: URL_BASE_DOC,
      editorContent: "",
      isLoading: false,
      transportTypeList: [
        {
          transportTypeVal: "SeaImport",
          transportTypeText: "Sea"
        }
      ],
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L"
        },

        {
          blTypeVal: "MasterBL",
          blTypeTxt: "Master B/L"
        }
      ],
      blTypeListLcl: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L"
        },

        {
          blTypeVal: "Co-Loader",
          blTypeTxt: "Co-Loader"
        }
      ],

      cctypeList: [
        {
          ccTypeVal: "Own",
          ccTypeTxt: "Own"
        },
        {
          ccTypeVal: "Outsourced",
          ccTypeTxt: "Outsourced"
        }
      ],

      containerInfoList: [
        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation"
        },
        {
          containerInfoVal: "LclConsolidation",
          containerInfoText: "LCL Consolidation"
        }
      ],
      deliveryModeList: [
        {
          deliveryModeVal: "uptoAirport",
          deliveryModeText: "upto Airport "
        },
        {
          deliveryModeVal: "DOOR",
          deliveryModeText: "DOOR"
        }
      ],

      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_"
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_"
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA"
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR"
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF"
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP"
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT"
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF"
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES"
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ"
        }
      ],

      oceanFreightTermsList: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid"
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect"
        }
      ],

      showAdd: false,

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin"
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination"
        }
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1"
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2"
        }
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      allAgentColoader: [],
      CommodityAll: {},
      autoClientName: {},
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],
      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],
      blRegexError: "",
      houseblRegexError: "",

      ffHouseBL: {
        conSeaMultiBlId: "",
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "HouseBL",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        importerClientId: "",
        exporterClientId: "",
        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],
        ccType: "",
        ccCha: "",
        shipType: "",
        agentName: "",
        sourceOriginclientId: "",
        buyer: "",
        buyingHouse: "",
        otherSpecify: "",
        houseMarksNos: "",
        houseContainerSealNo: "",
        houseDeliveryMode: "",
        houseCommodity: "",
        houseDescriptionGood: "",
        doorFPOd: "",
        houseNoOfPkg: "",
        houseVolumeWeightCargo: "",
        houseFinalChargeableWeight: "",
        deliveryTerms: "",
        remarks: "",
        houseGrossWeightCargo: "",
        finalPlaceLocationId: ""
      },

      errorHouseBL: {
        secondBLNumber: "",
        importerClientId: "",
        exporterClientId: "",
        finalPlaceLocationId: "",
        ccType: ""
      },
      multipleHouseBLData: "",

      arrayErrorHouseBL: {
        secondBLNumber: "Enter B/L Number",
        importerClientId: "Select Importer Name",
        exporterClientId: "Select Exporter Name",
        finalPlaceLocationId: "Select Final Delivery Place",
        ccType: "Select CC Type"
      },
      ffExoprtDetail: {
        statusFinal: "",
        portType: "",
        conSeaImportId: "",
        jobType: [],
        transportType: "SeaImport",
        containerInfo: "",
        shippingId: "",
        flightDate: "",
        alertReceivedDate: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBlType: "MasterBL",
        firstBLRadio: "",
        firstOcFreghtTerms: "",
        firstBLupload: "",
        preCarriageBy: "",
        PORlocationId: "",
        PODLocationId: "",
        etaFinalPort: "",
        vesselVoyage: "",
        LPlocationId: "",

        etaDischargePort: "",

        ffExportremarks: "",
        cargoDestufLocationId: "",
        lastFreeDay: "",
        sailDate: "",
        freeDetentionDesti: ""
      },
      getDayFromDate: "",

      deleteId: "",

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: ""
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],

      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },
      errorAtleastOne: "",
      ffExportError: [
        "Select Type",
        "Select Sail Date",
        "Select Shipping Line Name",

        "Select Pre-Alert Date",
        "Enter BL Number",

        "Select Place of Recipt",

        "Select Port Of Discharge",
        "Select Loading Port"
      ],
      ffExporterrorList: {
        containerInfo: "",
        sailDate: "",
        shippingId: "",
        alertReceivedDate: "",
        firstBLNumber: "",
        PORlocationId: "",
        PODLocationId: "",
        LPlocationId: ""
      },
      getPortDischargeList: [],
      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment"
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment"
        }
      ],
      IcdPOrtList: [],
      CargoDesData: [],
      PortLoadList: [],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      jobTypeSelectVal: false,
      otherServicesVal: false,
      openShipper: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: ["agra"],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: ""
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    VueTrix,
    quillEditor
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    getColoaderNameList() {
      return this.getColoaderName;
    },
    firstBlUploadView() {
      return this.ffExoprtDetail.firstBLupload != ""
        ? this.ffExoprtDetail.firstBLupload.split(",")
        : [];
    },
    SecondBlUploadView() {
      return this.ffHouseBL.secondBLupload != ""
        ? this.ffHouseBL.secondBLupload.split(",")
        : [];
    }
  },
  methods: {
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "6",
        allMessageId: this.$sessionsStorage.get("editconSeaImportId"),
        statusMain: this.ffExoprtDetail.statusFinal
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus"
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    onCloseAddSeaImp() {
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportExec"
      });
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.ffExoprtDetail.notifyList.length]
      };
      this.ffHouseBL.notifyList.push(obj);
    },
    removeNotify(index) {
      this.ffHouseBL.notifyList.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.ffExoprtDetail.jobType = Array(
            this.showSegmentArray.length
          ).fill(true);
          this.jobTypeSelectVal = true;
        } else {
          this.ffExoprtDetail.jobType = Array(
            this.showSegmentArray.length
          ).fill(false);
          this.jobTypeSelectVal = false;
        }
      }
    },

    validateFFExport(id) {
      let validate_new = true;
      let id22 = 0;

      var blformat = new RegExp("^[0-9]{11}$");

      if (blformat.test(this.ffExoprtDetail.firstBLNumber)) {
        this.blRegexError = "";
      } else {
        this.blRegexError = "Enter Valid Format";
        validate_new = false;
        window.scroll(0, 200);
      }

      Object.keys(this.ffExporterrorList).map((x, index) => {
        if (this.ffExoprtDetail[x] == "") {
          this.ffExporterrorList[x] = this.ffExportError[index];
          validate_new = false;
          id22 = 1;
        }
      });
      if (id == "") {
        if (blformat.test(this.ffHouseBL.secondBLNumber)) {
          this.houseblRegexError = "";
        } else {
          this.houseblRegexError = "Enter Valid Format";
          validate_new = false;
          if (id22 == 0) {
            id22 = 2;
          }
        }
        Object.keys(this.errorHouseBL).map((x, index) => {
          if (this.ffHouseBL[x] == "") {
            this.errorHouseBL[x] = this.arrayErrorHouseBL[x];
            validate_new = false;
            if (id22 == 0) {
              id22 = 2;
            }
          }
        });
      }
      if (validate_new != true) {
        if (id22 == 1) {
          window.scroll(0, 100);
        } else if (id22 == 2) {
          window.scroll(0, 870);
        }

        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFFSeaImport(id) {
      // $("#clientId").focus();
      let newVal = [];
      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });
      this.ffExoprtDetail["jobTypeArry"] = newVal;

      this.validateFFExport(id);

      let new_data = {
        ffExoprtDetail: this.ffExoprtDetail,
        ffHouseBL: this.ffHouseBL
      };

      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "csfds";
      }

      if (this.validate != false) {
        $("#addButtonLoader1212").css("display", "none");
        $("#loader11212").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/addConseaImp.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.$sessionsStorage.set(
                "editconSeaImportId",
                data.conSeaImportId
              );

              this.ffExoprtDetail.conSeaImportId = data.conSeaImportId;
              $("#loader11212").css("display", "none");
              $("#addButtonLoader11212").css("display", "block");

              this.openShipper = false;
              if (id != "") {
                this.alert.content = "Data Updated Succesfully";
                this.$refs["alertAddSeaImp"].open();
              }
              Object.keys(this.ffHouseBL).map(x => {
                if (x == "notifyList") {
                  this.ffHouseBL[x] = [
                    {
                      inputValue: "",
                      text: ""
                    },
                    {
                      inputValue: "",
                      text: "Second"
                    }
                  ];
                } else {
                  this.ffHouseBL[x] = "";
                }
              });

              Object.keys(this.errorHouseBL).map(x => {
                this.errorHouseBL[x] = "";
              });
              Object.keys(this.ffExporterrorList).map(x => {
                this.ffExporterrorList[x] = "";
              });
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    EditHouseBL(item) {
      this.ffHouseBL.notifyList = [];
      this.openShipper = true;
      Object.keys(this.ffHouseBL).map(x => {
        if (x == "notifyList") {
          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyListArray[index]
            };

            this.ffHouseBL.notifyList.push(obj);
          });
        } else {
          this.ffHouseBL[x] = item[x] || "";
        }
      });
      console.log(this.ffHouseBL);
    },
    onFileChangeFirstBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          this.ffExoprtDetail.firstBLupload = result.data;
        })
        .catch(err => {
          throw err;
        });
    },

    containerNoRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");
      let arrayLen = [];

      if (blformat.test(this.ffExoprtDetail.firstBLNumber)) {
        this.blRegexError = "";
      } else {
        this.blRegexError = "Enter Valid Format";
      }
    },

    houseBLRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");
      let arrayLen = [];

      if (blformat.test(this.ffHouseBL.secondBLNumber)) {
        this.houseblRegexError = "";
      } else {
        this.houseblRegexError = "Enter Valid Format";
      }
    },

    onFileChangeSecondBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}/Api_FFSeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          this.ffHouseBL.secondBLupload = result.data;
        })
        .catch(err => {
          throw err;
        });
    },

    getData() {
      this.doLoading();
      let array = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/fetchConSeaImport1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (data.ffAirImportData.length > 0) {
              this.ffExoprtDetail.notifyList = [];
              Object.keys(this.ffExoprtDetail).map(x => {
                if (x == "jobType") {
                  array = data.ffAirImportData[0][x].split(",");
                } else {
                  this.ffExoprtDetail[x] = data.ffAirImportData[0][x] || "";
                }
              });
              this.ffExoprtDetail["jobType"] = [];
              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });
              if (data.ffAirImportData[0]["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsFinal;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            if (data.ffAirImportBL.length > 0) {
              this.multipleHouseBLData = data.ffAirImportBL;
            } else {
              this.multipleHouseBLData = [];
            }

            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData.filter(x => {
                return x.categoryType == "Agent";
              });

              this.getColoaderName = data.agentColoaderData.filter(x => {
                return x.categoryType == "CoLoader";
              });
            }
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            // if (data.LocationDetails.length > 0) {
            //   this.getAlllocationListData = data.LocationDetails;
            //   this.getPortDischargeList = data.LocationDetails.filter(x => {
            //     return x.locationType == "Sea_Port" || x.locationType == "Icd";
            //     // return x.locationType == "Air_Port";
            //   });

            //   this.IcdPOrtList = data.LocationDetails.filter(x => {
            //     return x.locationType == "Sea_Port" || x.locationType == "Icd";
            //   });

            //   this.getlocationListData = this.getAlllocationListData.filter(
            //     x => {
            //       return x.locationType != "Client_Factory";
            //     }
            //   );
            // }

            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.getPortDischargeList = data.LocationDetailsSEAPORT;

            this.CargoDesData = data.LocationDetailsFinal;
            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient"
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/conSeaImport/conviewSeaImpDetails"
      });
    },
    showMoreShipper() {
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20"
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20"
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20"
        }

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.quill-editor{
  width: 330px !important;
}
</style>


// WEBPACK FOOTER //
// ffConSeaImportFcl.vue?71079e5e